import React from 'react/addons';

var CarouselItem = React.createClass({

  render() {
    var style = {
      left: `${this.props.baseOffset}%`
    };

    return (
      <li className="ofs-Carousel__Item" style={style}>
        {this.props.children}
      </li>
    );
  }
});


export default CarouselItem;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/carousel/CarouselItem.jsx
 **/